import type { CartLine, ProgramConfig, RoleCapacity, StaffingRole } from '../types/volunteer';

export const LEGAL_DISCLAIMER =
  'Automatically applied to your cart. Only available as part of this applicable registration transaction for selected program while discount opportunities remain. Valid for one Volunteer Registration Discount per volunteering customer, per program, regardless of the number of children you are registering. Cannot be applied retroactively. Non-transferrable. Cannot be applied to prior purchases.';

export const SAMPLE_MESSAGE =
  "We'd love to have you on the team! No experience needed – we'll give you everything you need to succeed.";

export const AMOUNT_PRESETS = [25, 50, 75, 100];
export const MESSAGE_MAX = 150;
export const PLACEHOLDER_HOLD_MINUTES = 30;

export const programInfo = {
  name: 'Spring 2027 Flag Football',
  id: '169525',
  franchise: 'i9 Sports of North Tampa',
  season: 'Spring 2027 · Saturdays · Mar 6 – May 8',
};

export const defaultRoles: RoleCapacity[] = [
  { id: 'head', label: 'Head Coach', opportunities: 4, claimed: 2 },
  { id: 'assistant', label: 'Assistant Coach', opportunities: 4, claimed: 3 },
  { id: 'helper', label: 'Helper', opportunities: 2, claimed: 0 },
];

export const defaultStaffing: StaffingRole[] = [
  { id: 'head', label: 'Head Coach', plural: 'Head Coaches', needed: true, count: 6 },
  { id: 'assistant', label: 'Assistant Coach', plural: 'Assistant Coaches', needed: true, count: 6 },
  { id: 'helper', label: 'Helper', plural: 'Helpers', needed: true, count: 4 },
];

export const defaultConfig: ProgramConfig = {
  discountEnabled: true,
  amount: 50,
  roles: defaultRoles,
  staffing: defaultStaffing,
  message: SAMPLE_MESSAGE,
  coachCreditEnabled: false,
};

export const cartItems: CartLine[] = [
  { id: 'p1', label: 'Mason Rivera', detail: 'Flag Football · Ages 5–7', amount: 189, kind: 'item' },
  { id: 'p2', label: 'Ava Rivera', detail: 'Flag Football · Ages 8–10', amount: 189, kind: 'item' },
];

export const cartAdjustments: CartLine[] = [
  { id: 'multi', label: 'Multi-child discount', detail: '2nd child', amount: -20, kind: 'adjustment' },
  { id: 'member', label: 'Member credit', detail: 'Account credit on file', amount: -15, kind: 'adjustment' },
];
